/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

import { CoreConfigService, CoreMediaService, CoreTranslationService } from '@xbaht/ui/core/services';
import { CoreSidebarService } from '@xbaht/ui/core/components/core-sidebars/core-sidebar/services/core-sidebar.service';
import { GlobalUserState, NgRxState } from '@xbaht/common/modules/app-ngrx.module';
import { GlobalAuthAction, GlobalPermAction, GlobalUserAction } from '@xbaht/common/stored/global/actions';
import { AuthenticationStore } from '@xbaht/common/stored/components/authentication.store';

import { locales } from './../../../../localizations/navbar';

import { environment } from 'environments/environment';

@Component({
  selector: 'xbaht-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  public environment = environment;

  public horizontalMenu?: boolean;
  public hiddenMenu?: boolean;

  public coreConfig: any;
  public currentSkin!: string;
  public prevSkin?: string | null;

  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;

  public user$!: Observable<GlobalUserState>;

  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    if (
      (window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.scrollY) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  private _unsubscribes: Subscription[] = [];

  constructor(
    private _router: Router,
    private _ngrxStore: Store<NgRxState>,
    private _cookieService: CookieService,
    private _authenticationStore: AuthenticationStore,
    private _coreTranslationService: CoreTranslationService,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService
  ) {
    this.languageOptions = {
      en: {
        title: 'English',
        flag: 'us',
      },
    };
  }

  ngOnInit(): void {
    this.user$ = this._ngrxStore.select('User');

    this._coreTranslationService.translate(...locales);

    this._unsubscribes.push(this._coreConfigService.config
      .subscribe(
        (config: {
          layout: { type: string; menu: { hidden: boolean }; skin: string };
        }) => {
          this.coreConfig = config;
          this.horizontalMenu = config.layout.type === 'horizontal';
          this.hiddenMenu = config.layout.menu.hidden === true;
          this.currentSkin = config.layout.skin;

          if (this.coreConfig.layout.type === 'vertical') {
            setTimeout(() => {
              if (this.coreConfig.layout.navbar.type === 'fixed-top') {
                this.isFixed = true;
              }
            }, 0);
          }
        }
      ));

    if (this.coreConfig.layout.type == 'horizontal') {
      this._unsubscribes.push(this._coreMediaService.onMediaUpdate
        .subscribe(() => {
          const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
          if (isFixedTop) {
            this.isFixed = false;
          } else {
            this.isFixed = true;
          }
        }));
    }

    this.selectedLanguage = _.find(this.languageOptions, {
      id: this._translateService.currentLang,
    });

    this._unsubscribes.push(
      this._authenticationStore
        .select((item) => item.signOut)
        .subscribe((value) => {
          if (value && value.event?.processing == false)
          {
            this._ngrxStore.dispatch(GlobalAuthAction.ResetAll());
            this._ngrxStore.dispatch(GlobalPermAction.ResetAll());
            this._ngrxStore.dispatch(GlobalUserAction.ResetAll());

            this._cookieService.deleteAll();

            location.reload();
          }
        })
    );
  }

  ngOnDestroy(): void {
    this._unsubscribes.forEach((_) => _.unsubscribe());
  }

  public toggleSidebar(key: any): void {
    this._coreSidebarService.getSidebarRegistry(key)?.toggleOpen();
  }

  public setLanguage(language: string): void {
    this.selectedLanguage = language;

    this._translateService.use(language);

    this._coreConfigService.setConfig(
      { app: { appLanguage: language } },
      { emitEvent: true }
    );
  }

  public toggleDarkSkin() {
    this._unsubscribes.push(this._coreConfigService
      .getConfig()
      .subscribe((config) => {
        this.currentSkin = config.layout.skin;
      }));

    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig(
        { layout: { skin: 'dark' } },
        { emitEvent: true }
      );
    }
  }

  public onSignOut() {
    this._authenticationStore.signOut();
  }
}
